import { useParams } from "react-router-dom";

import { BreadcrumbNavigation } from "components/common/BreadcrumbNavigation";
import { ProjectSwitcherContainer } from "components/layout/shell/AppSidebar/project/ProjectSwitcherContainer";
import { useCreateProjectLauncher } from "hooks/project";
import { useWorkspaceIdentifiers } from "hooks/useWorkspace";
import { useProjectIdentifiers } from "store/hooks/useProjectIdentifiers";

/**
 * The header breadcrumb of the project area. Inside a project it starts
 * with the project and draft switchers, then the page. Elsewhere (the
 * all-projects page, or while the project loads) it is the route breadcrumb.
 */
export const ProjectHeaderBreadcrumb = () => {
  const { projectId: routeProjectId } = useParams<{ projectId?: string }>();
  const isProjectRoute = Boolean(routeProjectId && routeProjectId !== "0");
  const { workspaceId } = useWorkspaceIdentifiers();
  const { project } = useProjectIdentifiers();
  const {
    launchCreateProject,
    createProjectFlowElement,
    canCreateWorkspaceProject,
    isWorkspaceAuthLoading,
  } = useCreateProjectLauncher();

  const showSwitchers = isProjectRoute && Boolean(project) && Boolean(workspaceId);

  return (
    <>
      <BreadcrumbNavigation
        projectSwitcher={
          showSwitchers && project && workspaceId ? (
            <ProjectSwitcherContainer
              workspaceId={workspaceId}
              project={project}
              canCreateProject={!isWorkspaceAuthLoading && canCreateWorkspaceProject}
              onNewProject={() => launchCreateProject()}
            />
          ) : undefined
        }
      />
      {createProjectFlowElement}
    </>
  );
};
